import React, { useEffect, useState } from 'react'
import axios from 'axios'

const Cart = ({state, dispatch}) => {
    let {cart}= state
    console.log(cart)
    let [total, setTotal] = useState(0)
    let changeqty = (id, qty)=>{
        dispatch({
            type:"changeproductqty",
            payload:{
                id,
                qty
            }
        })
    }
    useEffect(()=>{
        setTotal(cart.reduce((acc, curr)=>{
           return acc+Number(curr.price)*curr.qty
        }, 0))
    }, [cart])

    let checkouthandler =async (amount)=>{
        let {key}= await axios.get("https://server-n6zw.vercel.app/apikey")
        let {data } = await axios.post("https://server-n6zw.vercel.app/checkout", {
            amount
        })
        // console.log(window)
        var options = {
            key, // Enter the Key ID generated from the Dashboard
            amount: data.amount, // Amount is in currency subunits. Default currency is INR. Hence, 50000 refers to 50000 paise
            currency: "INR",
            name: "Naman's account",
            description: "Test Transaction",
            image: "https://example.com/your_logo",
            order_id: data.id, //This is a sample Order ID. Pass the `id` obtained in the response of Step 1
            callback_url: "https://server-n6zw.vercel.app/verification",
            prefill: {
                name: "Gaurav Kumar",
                email: "gaurav.kumar@example.com",
                contact: "9000090000"
            },
            notes: {
                address: "Razorpay Corporate Office"
            },
            theme: {
                color: "#3399cc"
            }
        };
        var razor = new window.Razorpay(options);
            razor.open();
        
    }

  return (
    <div style={{width:"30%", textAlign:"center"}}>
    <h3>Cart</h3>
    <h5>
        Subtotal : $ {total} 
        {
            cart.length>0 && 
            <button style={{color:"white", backgroundColor:"green", margin:"5px", cursor:"pointer", borderRadius:"10px"}} 
               onClick={()=>{
                   checkouthandler(total)
               }}
           >CheckOut</button>

        }
    </h5>
    <div>
        {
            cart.length > 0 ? 
            <div>
                {
                    cart.map((c, i)=>{
                        return <div key={i}>
                            <img src={c.thumbnail} alt="" width={"100px"} height={"100px"}/>
                            <div>
                                <button onClick={()=>{
                                    changeqty(c.id, c.qty-1)
                                }} >-</button>
                                <span>{c.qty}</span>
                                <button onClick={()=>{
                                    changeqty(c.id, c.qty+1)
                                }} >+</button>
                            </div>
                            <h4>$ {c.price}</h4>
                        </div>
                    })
                }
            </div>
            :
            <h5>Cart is empty!</h5>
        }
    </div>
    </div>
  )
}

export default Cart